const breakpoints = ['319px', '540px', '992px', '1200px']; // originally 599px. Changed for consistency, but need to verify for all scenarios. If there's no issue, let's stick to 540px

export default breakpoints;
